export interface NavItem {
	label: string;
	href: string;
	description?: string;
}

export const mainNavigation: NavItem[] = [
	{
		label: 'AI Lab',
		href: '/ai-lab',
		description: 'Learn AI by playing — free interactive modules and games'
	},
	{
		label: 'Masterclass',
		href: '/masterclass',
		description: 'Live 90-minute app build session'
	},
	{
		label: 'Courses',
		href: '/courses',
		description: 'Free live sessions and paid cohort courses'
	},
	{
		label: 'Dev Services',
		href: '/dev-services',
		description: 'AI-accelerated MVP development'
	},
	{
		label: 'Blog',
		href: '/blog',
		description: 'Insights and tutorials'
	},
	{
		label: 'About',
		href: '/about',
		description: 'The story and mission behind Akonia Codex'
	},
	{
		label: 'Contact',
		href: '/contact',
		description: 'Get in touch'
	}
];

export const footerNavigation = {
	services: [
		{ label: 'AI Lab', href: '/ai-lab' },
		{ label: 'Courses', href: '/courses' },
		{ label: 'Dev Services', href: '/dev-services' }
	],
	company: [
		{ label: 'About', href: '/about' },
		{ label: 'Blog', href: '/blog' },
		{ label: 'Contact', href: '/contact' }
	],
	legal: [
		{ label: 'Privacy Policy', href: '/privacy' },
		{ label: 'Terms of Service', href: '/terms' }
	]
};

export const socialLinks = [
	{
		label: 'LinkedIn',
		href: 'https://linkedin.com/company/akonia-codex',
		icon: 'linkedin'
	},
	{
		label: 'Twitter',
		href: 'https://twitter.com/akoniacodex',
		icon: 'twitter'
	},
	{
		label: 'YouTube',
		href: 'https://www.youtube.com/@akoniacodex',
		icon: 'youtube'
	},
	{
		label: 'Instagram',
		href: 'https://www.instagram.com/akoniacodex/',
		icon: 'instagram'
	}
];
